module.exports = __webpack_public_path__ + "static/img/6.b9f0580.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsdh/6.png
// module id = Cf3j
// module chunks = 0